import { useSelector } from "react-redux";
import { selectActors } from "../../../app/slices/TrainingSlice";
import PiCreatorDropdownItem from "../../../components/PiCreatorDropdown/PiCreatorDropdownItem";
import { useMemo } from "react";
import ActorAvatar from "../../../components/actors/ActorAvatar";
import PiCreatorDropdown from "../../../components/PiCreatorDropdown/PiCreatorDropdown";

export default function NodeActorDropdown(props: {
  label: string;
  selectedActorId: string;
  onClick: (actorId: string) => void;
}) {
  const actors = useSelector(selectActors);
  const selectedActor = actors.find((a) => a.id === props.selectedActorId);
  // dropdown items
  const dropdownItems = actors.map((a) => (
    <PiCreatorDropdownItem
      text={a.workingName}
      icon={<ActorAvatar theme="creator-selected" actor={a} size="24" />}
      onClick={() => props.onClick(a.id)}
    />
  ));

  const trigger = useMemo(
    () => (
      <div
        className={
          "flex items-center w-full h-full gap-[10px] px-[4px] text-creator-text-sub text-[20px]"
        }
      >
        <ActorAvatar theme="creator-selected" actor={selectedActor} size="24" />
        <div className={"my-auto font-normal text-[12px]"}>
          {selectedActor?.workingName ?? "No Actor"}
        </div>
      </div>
    ),
    [props.selectedActorId]
  );

  return (
    <PiCreatorDropdown
      style="small"
      label={props.label}
      trigger={trigger}
      items={dropdownItems as JSX.Element[]}
    />
  );
}
